import { render, staticRenderFns } from "./progressDetail.vue?vue&type=template&id=6f7aa5bc&scoped=true&"
import script from "./progressDetail.vue?vue&type=script&lang=js&"
export * from "./progressDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7aa5bc",
  null
  
)

export default component.exports